const scoreActions = {
  created_spaces: 10,
  created_rooms: 3,
  updated_spaces: 3,
  updated_rooms: 1,
  deleted_rooms: 1,
};

export default scoreActions;
